import React from 'react';

const ShellSVG: React.FC = () => (
  <svg viewBox="0 0 48 14" width="48" height="14">
    {/* Shell casing */}
    <rect x="10" y="4" width="28" height="6" rx="3" fill="#b8960c" />
    {/* Brass shine */}
    <rect x="12" y="4" width="24" height="2" rx="1" fill="#e8c030" opacity="0.8" />
    {/* Rim groove */}
    <rect x="10" y="8.5" width="6" height="1.5" rx="0.5" fill="#8a6e08" />
    {/* Projectile tip */}
    <ellipse cx="38" cy="7" rx="10" ry="3.5" fill="#c0c0c0" />
    <ellipse cx="40" cy="6.5" rx="7" ry="2.2" fill="#d8d8d8" />
    <ellipse cx="42" cy="6.2" rx="4" ry="1.5" fill="rgba(255,255,255,0.6)" />
    {/* Primer cap */}
    <circle cx="10" cy="7" r="3.5" fill="#7a5c06" />
    <circle cx="10" cy="7" r="2"   fill="#5a4204" />
    {/* Tracer glow trail */}
    <ellipse cx="3" cy="7" rx="8" ry="3" fill="rgba(255,140,0,0.55)" />
    <ellipse cx="0" cy="7" rx="4" ry="1.5" fill="rgba(255,80,0,0.35)" />
  </svg>
);

export default ShellSVG;
